import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  interpreterProfile: [],
  error: null,
  loader: false,
}

export const interpreterProfileSlice = createSlice({
  name: 'interpreterProfile',
  initialState: initialState,
  reducers: {
    setInterpreterProfile: (state, { payload }) => {
      state.interpreterProfile = payload?.data ?? payload;
    },
    setInterpreterProfiles: (state, { payload }) => {
      state.interpreterProfile = payload?.data;
    },
    removeInterpreterProfile: (state, { payload }) => {
      state.error = payload
    },
    clearAllInterpreterProfile: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const fetchInterpreterProfile = (data) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
  
      const json = await Api.fetchInterpreterProfile(data)
      if (json.status >= 200 && json.status < 300) {
        dispatch(setInterpreterProfiles(json.data))
        // callback(true, json.data.message)
        dispatch(setLoader(false))
      } else if (json.status == 422) {
        dispatch(setError(json.data))
        // callback(false, json.data.message)
        dispatch(setLoader(false))
      }else{
        dispatch(setLoader(false))
      }
    } catch (error) {
      console.log(error)
      dispatch(setLoader(false))
      // callback(false)
    }
  }
  
export const updateInterpreterProfile = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateInterpreterProfile(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setType(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}


// export const changePassword = (data, callback) => async (dispatch) => {
//     const apiService = new Api();
//     dispatch(setError({}))
//     dispatch(setLoader(true))
//     try {
  
//       const json = await Api.changePassword(data)
//       if (json.status >= 200 && json.status < 300) {
//         callback(true, json.data.message)
//       } else if (json.status == 422) {
//         dispatch(setError(json.data))
//         callback(false, json.data.message)
//       }
//     } catch (error) {
//       console.log(error)
//       // callback(false)
  
//     }
//     dispatch(setLoader(false))
//   }


export const { setInterpreterProfile, setInterpreterProfiles, clearAllInterpreterProfile, setLoader, setError, setMoreInterpreterProfiles } = interpreterProfileSlice.actions


export default interpreterProfileSlice.reducer
export const interpreterProfileSelector = state => state.interpreterProfile


